import { useModal } from "@ebay/nice-modal-react";
import { Badge, Button, Dropdown, MenuProps } from "antd";
import BaseModal from "components/foundation/modal/BaseModal";
import { useAuth } from "global/context/AuthenticationContext";
import { startTransition, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { IoIosLogOut, IoIosNotificationsOutline } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { LuFileText } from "react-icons/lu";
import { MdLockOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Format from "utils/format/Format";
import ListNoti from "../foundation/noti/ListNoti";
import ChangePassword from "./modal/ChangePassword";
import { LuShoppingCart } from "react-icons/lu";

interface HeaderProps {
  onPress: Function;
}

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ onPress }: HeaderProps) {
  const navigate = useNavigate();

  const userModal = useModal(BaseModal);

  const { profile, onLogout, isAdmin, handleChangePass, isStaff } = useAuth();

  const [show, setShow] = useState(false);

  const showNoti = () => {
    setShow(!show);
  };

  const nav = (path: string) => {
    startTransition(() => {
      navigate(path);
    });
  };

  const navCart = () => {
    navigate("/shopping-cart");
  };

  const handleLog = () => {
    userModal
      .show({
        title: "Đăng xuất",
        children: <p>Bạn có chắc chắn muốn đăng xuất không?</p>,
        footer: [
          {
            title: "Xác nhận",
            htmlType: "submit",
            type: "primary",
          },
          {
            title: "Hủy",
            htmlType: "button",
          },
        ],
      })
      .then(() => {
        onLogout();
      })
      .catch(() => {});
  };

  const changePass = () => {
    userModal
      .show({
        title: "Đổi mật khẩu",
        children: <ChangePassword />,
        footer: [
          {
            title: "Xác nhận",
            htmlType: "submit",
            type: "primary",
          },
          {
            title: "Hủy",
            htmlType: "button",
          },
        ],
      })
      .then((values: any) => {
        const info = {
          oldPassword: values.oldPassword,
          newPassword: values.password,
        };

        handleChangePass(info);
      })
      .catch(() => {});
  };

  const items: MenuProps["items"] = [
    {
      key: "history-transaction",
      label: (
        <div className="flex items-center">
          <LuFileText className="color_secondary text-[20px] mr-[8px]" />
          <span className="ml-[4px]">Lịch sử giao dịch</span>
        </div>
      ),
      onClick: () => nav("/transaction"),
    },
    {
      key: "reset-password",
      label: (
        <div className="flex items-center">
          <MdLockOutline className="color_secondary text-[20px] mr-[8px]" />
          <span className="ml-[4px]">Đổi mật khẩu</span>
        </div>
      ),
      onClick: changePass,
    },
    {
      key: "support",
      label: (
        <div className="flex items-center">
          <IoCall className="color_secondary text-[20px] mr-[8px]" />
          <span className="ml-[4px]">Gửi yêu cầu hỗ trợ</span>
        </div>
      ),
      onClick: () => nav("/transaction"),
    },
  ];

  items.push({
    key: "logout",
    label: (
      <div className="flex items-center">
        <IoIosLogOut className="color_secondary text-[20px] mr-[8px]" />
        <span className="ml-[4px]">Thoát tài khoản</span>
      </div>
    ),
    onClick: handleLog,
  });

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
      className="px-[20px] md:px-[50px] header"
    >
      <Button
        type="link"
        className="sidebar-toggler sidebar-desktop"
        onClick={() => onPress(1)}
      >
        {toggler}
      </Button>

      <div
        className="flex justify-end lg:justify-end items-center"
        style={{ height: "100%" }}
      >
        <div style={{}} className="md:ml-[0px] mr-[10px] md:mr-[100px]">
          <span className="md:inline md:ml-[10px] text-[#1D2129] md:text-[14px] text-[12px] font-normal">
            Tổng Hạn Mức:
          </span>
          <span className="md:inline md:ml-[10px] text-[#1D2129] md:text-[14px] text-[14px] font-bold">
            {Format.Price(profile?.wallet?.balance || 0)}
          </span>
        </div>

        <div
          style={{ display: "flex", alignItems: "center" }}
          className="mr-[5px] cursor-pointer px-2 py-1 rounded-md transition duration-200"
          onClick={showNoti}
        >
          <Badge count={0} showZero>
            <IoIosNotificationsOutline size={20} />
          </Badge>
          <span className="hidden md:inline md:ml-[10px] w-[100px] text-[#1D2129] text-sm font-normal">
            Thông báo
          </span>
        </div>
        {!isStaff && (
          <div
            className="m-[10px] mr-[20px] bg-gray-100 p-2 rounded-full cursor-pointer 
               hover:bg-gray-200 active:scale-95 transition duration-200"
            onClick={navCart}
          >
            <LuShoppingCart size={18} />
          </div>
        )}
        <div>
          <Dropdown key="custom-dropdown" menu={{ items }} trigger={["click"]}>
            <Button
              className="mt-0"
              style={{
                height: 40,
                display: "flex",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <span style={{ marginRight: 3 }}>{profile?.phone_number}</span>
              <FaAngleDown />
            </Button>
          </Dropdown>
        </div>
      </div>
      {show && (
        <div className="absolute z-[10000] top-[50px] right-5 md:right-[280px]">
          <ListNoti />
        </div>
      )}
    </div>
  );
}

export default Header;
